import type { ReactNode } from "react";
import { cn } from "@/lib/utils/cn";

type Tone = "neutral" | "accent" | "aqua" | "danger" | "warn" | "ok";

const TONES: Record<Tone, string> = {
  neutral: "border-ink-500 text-haze-300 bg-ink-700/60",
  accent: "border-accent/40 text-accent bg-accent/10",
  aqua: "border-aqua/40 text-aqua bg-aqua/10",
  danger: "border-danger/40 text-danger bg-danger/10",
  warn: "border-warn/40 text-warn bg-warn/10",
  ok: "border-ok/40 text-ok bg-ok/10",
};

export function Badge({ tone = "neutral", className, children }: {
  tone?: Tone; className?: string; children: ReactNode;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded border px-1.5 py-0.5",
        "text-2xs font-semibold uppercase tracking-wider",
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
